import React from 'react';
type SectionHeadingProps = {
  numeral?: string;
  label: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  action?: React.ReactNode;
  as?: 'h1' | 'h2';
  id?: string;
};
export function SectionHeading({
  numeral,
  label,
  title,
  intro,
  action,
  as = 'h2',
  id
}: SectionHeadingProps) {
  const Tag = as;
  return <div className="grid gap-8 lg:grid-cols-[minmax(0,1.25fr)_minmax(0,1fr)] lg:items-end lg:gap-16" data-id="element-406" data-mp="3k0yjaffwbfce">
      <div data-id="element-407" data-mp="bkvkz0aob30q">
        <p className="t-label flex items-center gap-3 text-graphite" data-id="element-408" data-mp="bl59ejg2l24b">
          {numeral && <span className="t-numeral text-[1.05em] text-gold-deep" data-id="element-409" data-mp="gix2hgsgaua3">{numeral}</span>}
          {numeral && <span aria-hidden="true" className="text-gold" data-id="element-410" data-mp="1uabuixdig3k">
              ·
            </span>}
          <span data-id="element-411" data-mp="6rtyo7850174">{label}</span>
        </p>
        <Tag id={id} className={`${as === 'h1' ? 't-display' : 't-h2'} mt-5 max-w-[18ch]`} data-id="element-412" data-mp="uippb10uwqcs">
          {title}
        </Tag>
      </div>
      {(intro || action) && <div className="max-w-[56ch] lg:justify-self-end" data-id="element-413" data-mp="zc0w525o574p">
          {intro && <div className="t-lead text-graphite" data-id="element-414" data-mp="1taqrswfk9w5l">{intro}</div>}
          {action && <div className="mt-7" data-id="element-415" data-mp="1obnobgf8bxzq">{action}</div>}
        </div>}
    </div>;
}